import { render } from "./NormalPaymentInfo.vue?vue&type=template&id=6d2b72e3&scoped=true"
import script from "./NormalPaymentInfo.vue?vue&type=script&lang=js"
export * from "./NormalPaymentInfo.vue?vue&type=script&lang=js"

import "./NormalPaymentInfo.vue?vue&type=style&index=0&id=6d2b72e3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2b72e3"]])

export default __exports__